import React from "react"

class VoucherRedemption extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      voucher_code: '',
      show_voucher_input: true,
      voucher_code_error_message: '',
      voucher_applied: this.props.voucherApplied,
      voucher_savings: this.props.voucherSavings,
      loading_voucher: false,
      voucher_errors: []
    };

    this.toggleVoucherInputDisplay = this.toggleVoucherInputDisplay.bind(this);
    this.handleVocuerCode = this.handleVocuerCode.bind(this);
    this.applyVoucherCode = this.applyVoucherCode.bind(this);
    this.removeVoucherCode = this.removeVoucherCode.bind(this);
  }
  componentWillReceiveProps(props) {
    this.setState({
      voucher_applied: props.voucherApplied,
      voucher_savings: props.voucherSavings
    });
  }
  toggleVoucherInputDisplay() {
    if (this.props.processingState !== true) {
      this.setState(
        {
          show_voucher_input: !this.state.show_voucher_input
        },
        () => {
          if (!_.isEmpty(this.state.voucher_code_error_message)) {
            this.setState({
              voucher_code_error_message: '',
              voucher_errors: []
            });
          }
        }
      );
    }
  }
  handleVocuerCode(e) {
    this.setState({
      voucher_code: e.target.value
    });
    if (e.target.value === '') {
      this.setState({
        voucher_errors: [],
        voucher_code_error_message: ''
      });
    }
  }
  applyVoucherCode() {
    if (this.props.processingState !== true) {
      this.setState({
        loading_voucher: true,
        voucher_code_error_message: '',
        voucher_errors: []
      });
      $.ajax({
        url: this.props.voucherUrl,
        dataType: 'json',
        method: 'POST',
        data: {
          voucher: { code: this.state.voucher_code }
        },
        success: () => {
          this.setState({ loading_voucher: false });
          this.props.getSummary();
        },
        error: (jqXHR, textStatus, errorThrown) => {
          var response = JSON.parse(jqXHR.responseText);
          var errors = [];

          if (response.errors) {
            errors = response.errors;
          }
          this.setState({
            voucher_code_error_message: response.message,
            voucher_errors: errors,
            loading_voucher: false
          });
        }
      });
    }
  }

  removeVoucherCode() {
    this.setState({
      voucher_code_error_message: '',
      voucher_errors: [],
      loading_voucher: true
    });
    $.ajax({
      url: this.props.voucherUrl,
      dataType: 'json',
      method: 'DELETE',
      success: () => {
        this.props.getSummary();
        this.setState({
          voucher_code: '',
          show_voucher_input: true,
          loading_voucher: false
        });
      },
      error: (jqXHR, textStatus, errorThrown) => {
        if (textStatus) {
          this.setState({
            voucher_code_error_message: textStatus,
            show_voucher_input: false
          });
        }
      }
    });
  }

  render() {
    var loadingVoucher =
      this.state.loading_voucher === true ? (
        <div className="loading-voucher" />
      ) : (
        ''
      );
    var applyVoucherCode = '';
    var title =
      this.state.voucher_applied === true ? (
        <div>
          <h5>
            <i className="icon-ok-sign" /> Voucher Applied{' '}
            {this.props.processingState === false ? (
              <span className="pull-right" onClick={this.removeVoucherCode}>
                <strong>Remove</strong>
              </span>
            ) : (
              ''
            )}
          </h5>
          <span className="savings">
            Voucher Savings:{' '}
            <strong>&pound;{this.state.voucher_savings}</strong>
          </span>
        </div>
      ) : (
        <h5>Do you have a Voucher Code?</h5>
      );
    applyVoucherCode =
      this.state.voucher_applied === false ? (
        <div
          className={
            'apply ' + (this.state.show_voucher_input === false ? ' hide' : '')
          }
        >
          <input
            type="text"
            aria-label="voucher-input"
            onChange={this.handleVocuerCode}
            value={this.state.voucher_code}
          />
          <button
            className="grey-button"
            disabled={this.state.voucher_code === ''}
            onClick={this.applyVoucherCode}
          >
            Apply
          </button>
        </div>
      ) : (
        ''
      );
    return (
      <div
        className={
          'apply-a-voucher' +
          (this.state.voucher_applied === true ? ' applied' : '') +
          (this.props.viewMoreActive === true ? ' mini-view' : '') +
          (this.props.processingState === true &&
          this.state.voucher_applied === false
            ? ' hide'
            : '')
        }
      >
        {loadingVoucher}
        {title}
        <div
          className={
            'voucher-error ' +
            (this.state.voucher_code_error_message === '' ? 'hide' : '')
          }
        >
          {this.state.voucher_code_error_message.length && (
            <strong
              dangerouslySetInnerHTML={{
                __html: this.state.voucher_code_error_message
              }}
            />
          )}

          <ul className={this.state.voucher_errors.length === 0 ? 'hide' : ''}>
            {this.state.voucher_errors.map((error, index) => {
              return (
                <li key={index} dangerouslySetInnerHTML={{ __html: error }} />
              );
            })}
          </ul>
        </div>
        {applyVoucherCode}
        {this.props.orderType === 'MIXED' && (
          <p className="help-info">
            <i className="icon-info-sign" />
            Vouchers will not be applied to 'Reserve and Collect' items.
          </p>
        )}
      </div>
    );
  }
}

export default VoucherRedemption;
